var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.9,455h14.8v-56.7h15.7V385h-46.6v13.3h16.2L220.9,455z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.4,455l15.2-25.7l15.6,25.7h17.3l-24.4-37.3L316,385h-16.5l-12.6,20.8L273.7,385h-17l21.6,33.2L255.1,455H271.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.8,455h14.8v-56.7h15.7V385h-46.6v13.3h16.1V455z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M559.4,215.9v-0.8c-0.4-0.9-1-1.8-1.7-2.5L435.2,90c-0.7-0.7-1.6-1.3-2.5-1.7h-0.8c-0.8-0.4-1.7-0.7-2.6-0.9H183.8 c-4.8,0-8.8,3.9-8.8,8.8v236.2h-26.2c-4.8,0-8.8,3.9-8.8,8.8v157.5c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6H175v61.2 c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h367.5c2.3,0,4.5-0.9,6.2-2.6s2.6-3.9,2.6-6.2v-350v-0.5 C559.9,217.4,559.7,216.6,559.4,215.9L559.4,215.9z M437.5,117.3l92.7,92.7h-92.7V117.3z M157.5,350H420v140H157.5V350z M192.5,560 v-52.5h236.2c2.3,0,4.5-0.9,6.2-2.6s2.6-3.9,2.6-6.2V341.2c0-2.3-0.9-4.5-2.6-6.2s-3.9-2.6-6.2-2.6H192.5V105H420v113.8 c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h113.8V560H192.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.2aa87361413c3172b6116680d72e59fa.svg";
export { ForwardRef as ReactComponent };